import * as React from 'react';
import * as _ from 'lodash';
import { useState } from 'react';
import { TreeData } from '@atlaskit/tree';
import Client from '../models/client';

interface HelpDocumentsState {
  loading: boolean;
  helpDocuments: TreeData;
  globalHelpDocuments: TreeData;
  clientList: Client[];
  activeDocumentId: number | null;
  errorMessage: string;
  successMessage: string;
}

interface ContextValue extends HelpDocumentsState {
  dispatch: any;
}

const defaultState: HelpDocumentsState = {
  loading: false,
  helpDocuments: {} as TreeData,
  globalHelpDocuments: {} as TreeData,
  clientList: [],
  activeDocumentId: null,
  errorMessage: '',
  successMessage: ''
};

const HelpDocumentsContext = React.createContext<ContextValue>(null);

const HelpDocumentsConsumer = HelpDocumentsContext.Consumer;

const HelpDocumentsProvider = props => {
  const [state, setState] = useState<HelpDocumentsState>(defaultState);

  const dispatch = (newValue: any) => {
    setState(prevState => {
      if (!_.isEqual({ ...prevState }, { ...prevState, ...newValue })) {
        return { ...prevState, ...newValue };
      }
      return prevState;
    });
  };

  return <HelpDocumentsContext.Provider value={{ ...state, dispatch }}>{props.children}</HelpDocumentsContext.Provider>;
};

export { HelpDocumentsContext, HelpDocumentsProvider, HelpDocumentsConsumer };
